// for the ANA filter
// export const yearsInNursing = ["All","<2 years","2-4 years","5-9 years","10-19 years", "20+ years"];
// export const usersInProfession = ["All","<2 years","2-4 years","5-9 years","10-19 years", "20+ years"];
// export const yearsInNursingWyoming = ["All", "1-2 years", "2-7 years", "8-13 years", "14+ years"];

const today = new Date();
const month = today.getMonth() + 1;
let day = today.getDate();
if (month === 2 && day === 29) {
  day = 28;
}

export const months = [
  { name: 'January', value: '01' }, { name: 'February', value: '02' },
  { name: 'March', value: '03' }, { name: 'April', value: '04' },
  { name: 'May', value: '05' }, { name: 'June', value: '06' },
  { name: 'July', value: '07' }, { name: 'August', value: '08' },
  { name: 'September', value: '09' }, { name: 'October', value: '10' },
  { name: 'November', value: '11' }, { name: 'December', value: '12' }
];

export const getDaysInMonth = (month, year) => {
  if (!month) return 31; // Default to 31 if no month is selected yet
  // Using day 0 of the next month returns the last day of the current month
  // We use the year 2000 as a default leap-year-safe placeholder if no year is selected
  const y = year ? parseInt(year) : 2000;
  const m = parseInt(month);
  return new Date(y, m, 0).getDate();
};

export const demographic_map = [
  { name: 'Age', value: 'age' },
  { name: 'Gender', value: 'gender' },
  { name: 'Department', value: 'department' },
  { name: 'Role', value: 'role' },
  { name: 'Years in Profession', value: 'years_in_profession' },
];

export const demographic_label_map = {
  'age': 'Age',
  'gender': 'Gender',
  'department': 'Department',
  'role': 'Role',
  'years_in_profession': 'Years In Profession'
}

export const timespan = [
  "7 Days",
  "30 Days",
  "90 Days",
  "1 Year",
];

export const is_standard_timespan = (ts) => {
  return timespan.includes(ts)
}

export const age_range = [
  "Under 28",
  "28-34",
  "35-44",
  "45-54",
  "55-69",
  "Over 69"
];

export const roles = [
  "Admin Support (Clerk/Secretary/Receptionist)",
  "Advanced Practice Provider",
  "Advanced Practice Registered Nurse",
  "Certified Nursing Assistant",
  "Certified Registered Nurse Anesthetist",
  "Certified Registered Nurse Practitioner",
  "Chaplain/Spiritual Support",
  "Clinical Social Worker",
  "Clinical Support (Med. Assist., Phleb. etc.)",
  "Environmental Support/Transport",
  "Executive/Admin Director/Director",
  "Facilities/Maintenance/Security",
  "Finance/Accounting/Med. Rec./Billing",
  "Food Service Support",
  "Human Resource Specialist",
  "Leadership (Manager/Supervisor/Charge/Lead)",
  "Medical Doctor",
  "Nurse (RN/LPN)",
  "Nurse Practitioner",
  "Nurses Aide/Sitter/PCT/Extern/SNP",
  "Paramedic/EMT",
  "Patient Rep (Intake/Registration/Scheduler)",
  "Pharmacist",
  "Pharmacy Technician",
  "Physician",
  "Physician Assistant",
  "Physical Therapist",
  "Project Manager/Analyst/Coordinator/Marketing",
  "Quality/Safety/Risk/Education/Performance Improvement",
  "Registered Dietitian",
  "Resident Assistant",
  "Student",
  "Speech Therapist",
  "Technician (e.g., Surg., Lab, EKG, Rad.)",
  "Technologist (e.g., Surg., Lab, Rad.)",
  "Therapist (PT, OT, Respiratory, Speech, Music)",
  "Other"
];

/** @type {string[]} */
export const departments = [
  "Ambulatory Services",
  "Ante/Post Partum",
  "Cardio-pulmonary Services",
  "Case Management",
  "Center for Advanced Practice",
  "Central Supply/Sterile Processing",
  "Clinic Care Coordination/Informatics",
  "Clinical Education/Centers of Excellence",
  "Clinical Laboratory",
  "Clinical Logistics",
  "Critical Care Unit",
  "Diagnostic Imaging",
  "Emergency Services",
  "Employee & Community Health",
  "Engineering/Facilities/Warehouse",
  "Environmental Services",
  "Finance/Patient Financial Services",
  "Food & Nutrition",
  "Information Technology/Communications",
  "House Supervisors/Nursing Resources",
  "Human Resources",
  "Inpatient Units",
  "Integrated Marketing/Media Services",
  "Lab Outreach & Outpatient Services",
  "Labor and Delivery",
  "Leadership",
  "Medical Staffing",
  "Medical/Surgical Service Line",
  "NICU",
  "Outpatient Rehab Services (PT/OT/Speech)",
  "PACU",
  "Patient Access",
  "PICU",
  "Pharmacy",
  "Rehabilitation Services (inpatient)",
  "Safety/Security",
  "School",
  "Stepdown/Progressive Care Unit",
  "Strategy and Growth",
  "Supply Chain",
  "Surgical Services",
  "Talent Management",
  "Transition to Care",
  "Transporters",
  "Other"
];

/** @type {string[]} */
export const yearsInProfession = [
  "<2 years",
  "2-4 years",
  "5-9 years",
  "10-19 years",
  "20+ years"
];

/** @type {string[]} */
export const mayo_locations = [
  "New Prague, MN",
  "Menomonie, WI",
  "Eau Claire, WI",
  "Mankato, MN",
];

// Two-letter abbreviations are stored (matching the "City, ST" shape of mayo_locations);
// full names are shown in dropdowns.
export const us_states = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "DC", name: "District of Columbia" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
];

/** @type {string[]} */
export const genders = [
  "Male",
  "Female",
  "Non-binary",
  "Non-conforming",
  "Prefer not to answer",
];

export const ageRanges = [[0, 27], [28, 34], [35, 44], [45, 54], [55, 69], [70, 100]];

const userOptions = {
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Non-binary": "Non-binary",
    "Non-conforming": "Non-conforming",
    "Prefer not to answer": "Prefer not to answer"
  },
  "burnout_specialty": {
    "Allergy and Immunology": "Allergy and Immunology",
    "Alternative Medicine": "Alternative Medicine",
    "Anesthesiology": "Anesthesiology",
    "Cardiology": "Cardiology",
    "Cardiothoracic Surgery": "Cardiothoracic Surgery",
    "Colorectal Surgery": "Colorectal Surgery",
    "Comparative Medicine": "Comparative Medicine",
    "Cosmetic Surgery": "Cosmetic Surgery",
    "Dentistry": "Dentistry",
    "Dermatology": "Dermatology",
    "Emergency Medicine": "Emergency Medicine",
    "Endocrinology": "Endocrinology",
    "Family Medicine": "Family Medicine",
    "Gastroenterology and Hepatology": "Gastroenterology and Hepatology",
    "General Internal Medicine": "General Internal Medicine",
    "General Pediatrics": "General Pediatrics",
    "General Surgery": "General Surgery",
    "Genetics": "Genetics",
    "Geriatric Medicine": "Geriatric Medicine",
    "Hematology": "Hematology",
    "Hospital Medicine": "Hospital Medicine",
    "Infectious Disease": "Infectious Disease",
    "Intensive Care Medicine": "Intensive Care Medicine",
    "Microbiology and Immunology": "Microbiology and Immunology",
    "Nephrology": "Nephrology",
    "Neurology": "Neurology",
    "Neuroscience": "Neuroscience",
    "Neurosurgery": "Neurosurgery",
    "Obstetrics and Gynecology": "Obstetrics and Gynecology",
    "Occupational Medicine": "Occupational Medicine",
    "Oncology": "Oncology",
    "Optometry": "Optometry",
    "Ophthalmology": "Ophthalmology",
    "Orthopedics": "Orthopedics",
    "Otolaryngology": "Otolaryngology",
    "Otorhinolaryngology": "Otorhinolaryngology",
    "Pain Medicine": "Pain Medicine",
    "Palliative Care": "Palliative Care",
    "Pathology": "Pathology",
    "Pharmacology": "Pharmacology",
    "Physical Medicine": "Physical Medicine",
    "Plastic Surgery": "Plastic Surgery",
    "Podiatry": "Podiatry",
    "Preventative Medicine": "Preventative Medicine",
    "Primary Care": "Primary Care",
    "Psychiatry": "Psychiatry",
    "Pulmonology": "Pulmonology",
    "Radiation Oncology": "Radiation Oncology",
    "Radiology": "Radiology",
    "Reproductive Endocrinology": "Reproductive Endocrinology",
    "Rheumatology": "Rheumatology",
    "Sleep Medicine": "Sleep Medicine",
    "Sports Medicine": "Sports Medicine",
    "Toxicology": "Toxicology",
    "Transplant Surgery": "Transplant Surgery",
    "Trauma Surgery": "Trauma Surgery",
    "Urology": "Urology",
    "Vascular Surgery": "Vascular Surgery",
    "Wound Medicine": "Wound Medicine",
  },
  "feedback": {
    '': '',
    "Strongly Agree": "Strongly Agree",
    "Agree": "Agree",
    "Neutral": "Neutral",
    "Disagree": "Disagree",
    "Strongly Disagree": "Strongly Disagree",
  },

  "license_type": {
    "Physician": "Physician",
    "Nurse": "Nurse",
    "Certified Nurse Midwife": "Certified Nurse Midwife",
    "Certified Registered Nurse Anesthetist": "Certified Registered Nurse Anesthetist",
    "Certified Registered Nurse Practitioner": "Certified Registered Nurse Practitioner",
    "Dentist": "Dentist",
    // "Doctor of Optometry":"Doctor of Optometry",
    // "Doctor of Osteopathic Medicine":"Doctor of Osteopathic Medicine",
    "PhD / other doctoral degree": "PhD / other doctoral degree",
    // "Doctor of Podiatric Medicine":"Doctor of Podiatric Medicine",
    "EEG Technician": "EEG Technician",
    // "Licensed Practical Nurse":"Licensed Practical Nurse",
    "Nursing Assistant (CNA, PCT)": "Nursing Assistant (CNA, PCT)",
    "Occupational Therapist": "Occupational Therapist",
    "Optometrist": "Optometrist",
    "Pharmacist": "Pharmacist",
    "Pharmacy Technician": "Pharmacy Technician",
    "Physical Therapist": "Physical Therapist",
    "Physician Assistant": "Physician Assistant",
    "Radiology Technician": "Radiology Technician",
    "Registered Dietitian": "Registered Dietitian",
    // "Registered Nurse":"Registered Nurse",
    "Respiratory Therapist": "Respiratory Therapist",
    "Speech Therapist": "Speech Therapist",
    "Surgical Technician": "Surgical Technician",
  },
  // "age_range": {
  //   "Under 28": createDate(0, 0, -18),
  //   "28 - 34": createDate(0, 0, -28),
  //   "35 - 44": createDate(0, 0, -35),
  //   "45 - 54": createDate(0, 0, -45),
  //   "55 - 69": createDate(0, 0, -55),
  //   "Over 69": createDate(0, 0, -70),
  // },
  "age_range": {
    "Under 28": (month) + '/' + (day) + '/' + (today.getFullYear() - 24),
    "28 - 34": (month) + '/' + (day) + '/' + (today.getFullYear() - 28),
    "35 - 44": (month) + '/' + (day) + '/' + (today.getFullYear() - 35),
    "45 - 54": (month) + '/' + (day) + '/' + (today.getFullYear() - 45),
    "55 - 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 55),
    "Over 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 70),
  }
};

export const anaUserOptions = {
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Non-binary": "Non-binary",
    "Non-conforming": "Non-conforming",
    "Prefer not to answer": "Prefer not to answer"
  },
  "burnout_specialty": {
    "<2 years": "<2 years",
    "2-4 years": "2-4 years",
    "5-9 years": "5-9 years",
    "10-19 years": "10-19 years",
    "20+ years": "20+ years",
  },
  "feedback": {
    '': '',
    "Strongly Agree": "Strongly Agree",
    "Agree": "Agree",
    "Neutral": "Neutral",
    "Disagree": "Disagree",
    "Strongly Disagree": "Strongly Disagree",
  },
  "burnout_location": {
    "Acute Care/Hospital": "Acute Care/Hospital",
    "Ambulatory/Community Health": "Ambulatory/Community Health",
    "Education/School of Nursing": "Education/School of Nursing",
    "Long Term Care/Skilled Nursing Facility/Rehabilitation": "Long Term Care/Skilled Nursing Facility/Rehabilitation",
    "Other": "Other",
    "Not employed in nursing": "Not employed in nursing"
  },
  "license_type": {
    "Clinical Nurse/Staff Nurse": "Clinical Nurse/Staff Nurse",
    "Nurse Educator or Professor": "Nurse Educator or Professor",
    "Advance Practice Nurse (NP, CNS, CNM, CRNA)": "Advance Practice Nurse",
    "Nurse Manager": "Nurse Manager",
    "Executive/Director/CNO/ACNO": "Executive/Director/CNO/ACNO",
    "Other position in nursing": "Other position in nursing",
    "Unemployed": "Unemployed",
    "Retired": "Retired"
  },
  // "age_range": {
  //   "Under 28": createDate(0, 0, -18),
  //   "28 - 34": createDate(0, 0, -28),
  //   "35 - 44": createDate(0, 0, -35),
  //   "45 - 54": createDate(0, 0, -45),
  //   "55 - 69": createDate(0, 0, -55),
  //   "Over 69": createDate(0, 0, -70),
  // },
  "age_range": {
    "Under 28": (month) + '/' + (day) + '/' + (today.getFullYear() - 24),
    "28 - 34": (month) + '/' + (day) + '/' + (today.getFullYear() - 28),
    "35 - 44": (month) + '/' + (day) + '/' + (today.getFullYear() - 35),
    "45 - 54": (month) + '/' + (day) + '/' + (today.getFullYear() - 45),
    "55 - 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 55),
    "Over 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 70),
  }
};

export const chamberlainUserOptions = {
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Non-binary": "Non-binary",
    "Non-conforming": "Non-conforming",
    "Prefer not to answer": "Prefer not to answer"
  },
  "burnout_specialty": {
    "<2 years": "<2 years",
    "2-4 years": "2-4 years",
    "5-9 years": "5-9 years",
    "10-19 years": "10-19 years",
    "20+ years": "20+ years",
  },
  "burnout_location": {
    "Acute Care": "Acute Care",
    "Outpatient/Ambulatory": "Outpatient/Ambulatory",
    "Long-term Care": "Long-term Care",
    "Hospice": "Hospice",
    "Home Health": "Home Health",
    "School Nurse": "School Nurse",
    "Other": "Other"
  },
  "license_type": {
    "Employed full-time": "Employed full-time",
    "Employed part-time": "Employed part-time",
    "Employed Per diem": "Employed Per diem",
    "Not Employed": "Not Employed",
    "Other": "Other"
  },
  "feedback": {
    '': '',
    "Strongly Agree": "Strongly Agree",
    "Agree": "Agree",
    "Neutral": "Neutral",
    "Disagree": "Disagree",
    "Strongly Disagree": "Strongly Disagree",
  },
  "age_range": {
    "Under 28": (month) + '/' + (day) + '/' + (today.getFullYear() - 24),
    "28 - 34": (month) + '/' + (day) + '/' + (today.getFullYear() - 28),
    "35 - 44": (month) + '/' + (day) + '/' + (today.getFullYear() - 35),
    "45 - 54": (month) + '/' + (day) + '/' + (today.getFullYear() - 45),
    "55 - 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 55),
    "Over 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 70),
  }
}

export const cppUserOptions = {
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Non-binary": "Non-binary",
    "Non-conforming": "Non-conforming",
    "Prefer not to answer": "Prefer not to answer"
  },
  "feedback": {
    '': '',
    "Strongly Agree": "Strongly Agree",
    "Agree": "Agree",
    "Neutral": "Neutral",
    "Disagree": "Disagree",
    "Strongly Disagree": "Strongly Disagree",
  },
  "age_range": {
    "Under 28": (month) + '/' + (day) + '/' + (today.getFullYear() - 24),
    "28 - 34": (month) + '/' + (day) + '/' + (today.getFullYear() - 28),
    "35 - 44": (month) + '/' + (day) + '/' + (today.getFullYear() - 35),
    "45 - 54": (month) + '/' + (day) + '/' + (today.getFullYear() - 45),
    "55 - 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 55),
    "Over 69": (month) + '/' + (day) + '/' + (today.getFullYear() - 70),
  },
  "burnout_specialty": {
    "Allergy and Immunology": "Allergy and Immunology",
    "Alternative Medicine": "Alternative Medicine",
    "Anesthesiology": "Anesthesiology",
    "Cardiology": "Cardiology",
    "Cardiothoracic Surgery": "Cardiothoracic Surgery",
    "Colorectal Surgery": "Colorectal Surgery",
    "Comparative Medicine": "Comparative Medicine",
    "Cosmetic Surgery": "Cosmetic Surgery",
    "Dentistry": "Dentistry",
    "Dermatology": "Dermatology",
    "Emergency Medicine": "Emergency Medicine",
    "Endocrinology": "Endocrinology",
    "Family Medicine": "Family Medicine",
    "Gastroenterology and Hepatology": "Gastroenterology and Hepatology",
    "General Internal Medicine": "General Internal Medicine",
    "General Pediatrics": "General Pediatrics",
    "General Surgery": "General Surgery",
    "Genetics": "Genetics",
    "Geriatric Medicine": "Geriatric Medicine",
    "Hematology": "Hematology",
    "Hospital Medicine": "Hospital Medicine",
    "Infectious Disease": "Infectious Disease",
    "Intensive Care Medicine": "Intensive Care Medicine",
    "Microbiology and Immunology": "Microbiology and Immunology",
    "Nephrology": "Nephrology",
    "Neurology": "Neurology",
    "Neuroscience": "Neuroscience",
    "Neurosurgery": "Neurosurgery",
    "Obstetrics and Gynecology": "Obstetrics and Gynecology",
    "Occupational Medicine": "Occupational Medicine",
    "Oncology": "Oncology",
    "Optometry": "Optometry",
    "Ophthalmology": "Ophthalmology",
    "Orthopedics": "Orthopedics",
    "Otolaryngology": "Otolaryngology",
    "Otorhinolaryngology": "Otorhinolaryngology",
    "Pain Medicine": "Pain Medicine",
    "Palliative Care": "Palliative Care",
    "Pathology": "Pathology",
    "Pharmacology": "Pharmacology",
    "Physical Medicine": "Physical Medicine",
    "Plastic Surgery": "Plastic Surgery",
    "Podiatry": "Podiatry",
    "Preventative Medicine": "Preventative Medicine",
    "Primary Care": "Primary Care",
    "Psychiatry": "Psychiatry",
    "Pulmonology": "Pulmonology",
    "Radiation Oncology": "Radiation Oncology",
    "Radiology": "Radiology",
    "Reproductive Endocrinology": "Reproductive Endocrinology",
    "Rheumatology": "Rheumatology",
    "Sleep Medicine": "Sleep Medicine",
    "Sports Medicine": "Sports Medicine",
    "Toxicology": "Toxicology",
    "Transplant Surgery": "Transplant Surgery",
    "Trauma Surgery": "Trauma Surgery",
    "Urology": "Urology",
    "Vascular Surgery": "Vascular Surgery",
    "Wound Medicine": "Wound Medicine",
  },
  "burnout_location": {

  },
  "license_type": {
    "Advanced Practice Registered Nursing (CRNA, CNM, CRNP)": "Advanced Practice Registered Nursing (CRNA, CNM, CRNP)",
    "Clinical Support (Med. Assist., Phleb. etc.)": "Clinical Support (Med. Assist., Phleb. etc.)",
    "Executive/Admin Director/Director": "Executive/Admin Director/Director",
    "Finance/Accounting/Med. Rec./Billing": "Finance/Accounting/Med. Rec./Billing",
    "Leadership (Manager/Supervisor/Charge/Lead)": "Leadership (Manager/Supervisor/Charge/Lead)",
    "Nurse": "Nurse",
    "Patient Rep (Intake/Registration/Scheduler)": "Patient Rep (Intake/Registration/Scheduler)",
    "Physician": "Physician",
    "Physician Assistant": "Physician Assistant",
    "Technician (e.g., Surg., Lab, EKG, Rad.)": "Technician (e.g., Surg., Lab, EKG, Rad.)",
    "Therapist (PT, OT, Respiratory, Speech, Music)": "Therapist (PT, OT, Respiratory, Speech, Music)"
  }
}

export default userOptions;